import { CircularProgress, styled } from '@material-ui/core';
import ActionButton from './ActionButton';

const SpinnerWrapper = styled('div')({
  alignItems: 'center',
  height: '100%',
  position: 'absolute'
});

const Wrapper = styled('div')({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  position: 'relative'
});

const SubmitButton = ({ isLoading, children, disabled, ...rest }) => {
  return (
    <ActionButton disabled={isLoading || disabled} type="submit" {...rest}>
      <Wrapper>
        {children}
        {isLoading && (
          <SpinnerWrapper>
            <CircularProgress size={20} sx={{ ml: 2 }} />
          </SpinnerWrapper>
        )}
      </Wrapper>
    </ActionButton>
  );
};
export default SubmitButton;
